import {useEffect} from "react";

// hooks/useModalScrollLock.ts
export const useModalScrollLock = (isOpen: boolean) => {
    useEffect(() => {
        const scrollY = window.scrollY;
        const body = document.body;

        if (isOpen) {
            body.dataset.scrollPosition = scrollY.toString();
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
            body.style.top = `-${scrollY}px`;
            body.style.width = '100%';
        }

        return () => {
            if (!body.dataset.scrollPosition) return;

            // 저장된 위치로 복원
            const scrollY = parseInt(body.dataset.scrollPosition);
            body.style.overflow = '';
            body.style.position = '';
            body.style.top = '';
            body.style.width = '';
            window.scrollTo(0, scrollY);

            delete body.dataset.scrollPosition;
        };
    }, [isOpen]);
};